export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: '60px'
  },
  {
    title: '客户名称',
    dataIndex: 'name',
    ellipsis: true,
    width: '260px',
    scopedSlots: { customRender: 'hospitalName' },
  },
  {
    title: '省份',
    dataIndex: 'province',
    width: '100px'
  },
  {
    title: '城市',
    dataIndex: 'city',
    width: '100px'
  },
  {
    title: '客户地址',
    dataIndex: 'address',
    scopedSlots: { customRender: 'addressName' },
  },
  {
    title: '客户类型',
    dataIndex: 'type',
    width: '100px',
    customRender: (text, record, index) => {
      if (record.type === 0) {
        return '医院';
      } else if (record.new_type === 1) {
        return '药店';
      } else if (record.type === 3) {
        return '商业';
      } else {
        return '机构';
      }
    },
  },
  {
    title: '医院等级',
    dataIndex: 'dengji',
    width: '100px'
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    width: '190px'
  },
  // {
  //   title: '状态',
  //   dataIndex: 'status',
  //   customRender: (text, record, index)=>{
  //     return record.status===0?'禁用':'启用';
  //   },
  // },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '120px'
  },
];

export const columns1 = [
  {
    title: 'Excel行号',
    dataIndex: 'line',
    width: '6%',
    align: 'center'
  },
  {
    title: '合作企业',
    dataIndex: 'cooperativeEnterprise',
    width: '18%'
  },
  {
    title: '医院名称',
    dataIndex: 'hospitalName',
    width: '20%'
  },
  {
    title: '省份',
    dataIndex: 'province',
    width: '5%'
  },
  {
    title: '城市',
    dataIndex: 'city',
    width: '5%'
  },
  {
    title: '医院等级',
    dataIndex: 'grade',
    width: '7%'
  },
  {
    title: '医院地址',
    dataIndex: 'address',
    width: '20%'
  },
  // {
  //   title: '经度',
  //   dataIndex: 'lng',
  //  width:'8%'
  // },
  // {
  //   title: '纬度',
  //   dataIndex: 'lat',
  //  width:'8%'
  // },
  {
    title: '反馈信息',
    dataIndex: 'error_msg',
    scopedSlots: { customRender: 'error_msg' },
    width: '21%'
  },
];
export const columns2 = [
  {
    title: 'Excel行号',
    dataIndex: 'line',
    width: '6%',
    align: 'center'
  },
  {
    title: '名称',
    dataIndex: 'hospitalName',
    width: '20%'
  },
  {
    title: '省份',
    dataIndex: 'province',
    width: '5%'
  },
  {
    title: '城市',
    dataIndex: 'city',
    width: '5%'
  },
  {
    title: '地址',
    dataIndex: 'address',
    width: '20%'
  },
  {
    title: '反馈信息',
    dataIndex: 'error_msg',
    scopedSlots: { customRender: 'error_msg' },
    width: '21%'
  },
];
export const serverhospitaModalFormData = [
  {
    name: 'name',
    lable: '医院名称',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  },
  {
    name: 'hospital_grade',
    lable: '医院等级',
    lableCol: 4,
    wrapperCol: 18,
    class: 'hospital-grade-class',
  },
  {
    name: 'map',
    lable: '医院地址',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  },
]
export const businessFormData = [
  {
    name: 'provinceCity',
    lable: '所在省市',
    lableCol: 4,
    wrapperCol: 18,
    class: 'province-class',
  }, {
    name: 'name',
    lable: '客户名称',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  },
  {
    name: 'address',
    lable: '公司地址',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  }
]
export const hospitalFormData = [
  // {
  //   name: 'company_id',
  //   lable: '合作企业',
  //   lableCol: 4,
  //   wrapperCol: 18,
  //   class: 'name-class',
  // },
  {
    name: 'name',
    lable: '医院名称',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  },
  {
    name: 'provinceCity',
    lable: '所在省市',
    lableCol: 4,
    wrapperCol: 18,
    class: 'province-class',
  },
  {
    name: 'hospital_grade',
    lable: '医院等级',
    lableCol: 8,
    wrapperCol: 14,
    isSelect: true,
    class: 'hospital-grade-class',
  },

  {
    name: 'hospital_level',
    lable: '',
    lableCol: 0,
    wrapperCol: 20,
    isSelect: true,
    isSecond: true,
    class: 'hospital-level-class',
  },
  {
    name: 'address',
    lable: '医院地址',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name-class',
  },
  {
    name: 'cutOffRule',
    lable: '',
    lableCol: 0,
    wrapperCol: 24,
  },
  {
    name: 'incharge',
    lable: '医院信息',
    lableCol: 8,
    wrapperCol: 14,
    isSelect: true,
    class: 'incharge-class',
  },
  {
    name: 'zip_code',
    lable: '',
    lableCol: 0,
    wrapperCol: 20,
    isSelect: true,
    isSecond: true,
    class: 'zip-code-class',
  },
  // {
  //   name: 'address',
  //   lable: '',
  //   lableCol: 4,
  //   wrapperCol: 18,
  //   class: 'address-class',
  // },
  {
    name: 'summary',
    lableCol: 4,
    wrapperCol: 18,
    class: 'summary-class',
  },
  {
    name: 'unique_feature',
    lableCol: 4,
    wrapperCol: 18,
    class: 'unique-feature-class',
  },
  {
    name: 'hospital_class',
    lable: '医院类别性质',
    lableCol: 8,
    wrapperCol: 14,
    isSelect: true,
    class: 'hospital-class',
  },
  {
    name: 'hospital_nature',
    lable: '',
    lableCol: 0,
    wrapperCol: 20,
    isSelect: true,
    isSecond: true,
    class: 'hospital-nature-class',
  },
  {
    name: 'hospital_property_right_nature',
    lable: '医院性质',
    lableCol: 8,
    wrapperCol: 14,
    isSelect: true,
    class: 'hospital-property-class',
  },
  {
    name: 'hospital_profit_nature',
    lable: '',
    lableCol: 0,
    wrapperCol: 20,
    isSelect: true,
    isSecond: true,
    class: 'hospital-profit-class',
  },
];
export const drugstoreFormData = [
  {
    name: 'name1',
    lable: '药店名称',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name1-class',
  },
  {
    name: ',1',
    lable: '所在省市',
    lableCol: 4,
    wrapperCol: 18,
    class: 'province-class',
  },
  {
    name: 'incharge1',
    lable: '负责人',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
    class: 'incharge1-class',
  },
  {
    name: 'drugstore_kind',
    lable: '药店类型',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
    class: 'drugstore-kind-class',
  },

  {
    name: 'drugsCutOffRule',
    lable: '',
    lableCol: 0,
    wrapperCol: 24,
  },
  {
    name: 'zip_code1',
    lable: '药店信息',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
    class: 'zip-code1-class',
  },
  {
    name: 'address1',
    lable: '',
    lableCol: 4,
    wrapperCol: 18,
    class: 'address1-class',
  },
  {
    name: 'summary1',
    lableCol: 4,
    wrapperCol: 18,
    class: 'summary1-class',
  },
  {
    name: 'unique_feature1',
    lableCol: 4,
    wrapperCol: 18,
    class: 'unique-feature1-class',
  },
];
export const orgnizationFormData = [
  {
    name: 'name2',
    lable: '机构名称',
    lableCol: 4,
    wrapperCol: 18,
    class: 'name1-class',
  },
  {
    name: 'provinceCity2',
    lable: '所在省市',
    lableCol: 4,
    wrapperCol: 18,
    class: 'province-class',
  },
  {
    name: 'incharge2',
    lable: '负责人',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
    class: 'name1-class',
  },
  {
    name: 'institution_kind',
    lable: '机构类型',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
    class: 'name1-class',
  },

  {
    name: 'orgCutOffRule',
    lable: '',
    lableCol: 0,
    wrapperCol: 24,
  },
  {
    name: 'zip_code2',
    lable: '机构信息',
    lableCol: 8,
    wrapperCol: 16,
    isSelect: true,
  },
  {
    name: 'address2',
    lable: '',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'summary2',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'unique_feature2',
    lableCol: 4,
    wrapperCol: 18,
  },
];
export const contactColumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '姓名',
    dataIndex: 'name',
  },
  {
    title: '性别',
    dataIndex: 'sex',
    customRender: (text, record, index) => {
      if (record.sex === 0) {
        return '保密';
      } else if (record.sex === 1) {
        return '女';
      } else {
        return '男';
      }
    },
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
  },
  {
    title: '所在省份',
    dataIndex: 'province',
  },
  {
    title: '所在城市',
    dataIndex: 'city',
  },
  // {
  //   title: '状态',
  //   dataIndex: 'status',
  //   customRender: (text, record, index)=>{
  //     return record.status===0?'禁用':'启用';
  //   },
  // },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const contactFormData = [
  {
    name: 'real_name',
    lable: '姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'sex',
    lable: '性别',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'phone',
    lable: '联系电话',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'provinceCity',
    lable: '所在省市',
    lableCol: 4,
    wrapperCol: 18,
    class: 'province-class',
  },
  {
    name: 'address',
    lable: '详细地址',
    lableCol: 4,
    wrapperCol: 18,
  },
];
